/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Mark_UnpaidInputs */



/**
* | output |
* | --- |
* | "Mark as unpaid" |
*
* @param {Payment_Mark_UnpaidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_mark_unpaid = /** @type {((inputs?: Payment_Mark_UnpaidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Mark_UnpaidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer comme non payé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar como no pagado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar como não pago")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna come non pagato")
	return /** @type {LocalizedString} */ ("Mark as unpaid")
});